export const openUrl = (url) => {
  !!~url.indexOf("/", 2) || url.indexOf("http") === 0
    ? window.open(`${url}`, "_blank")
    : window.open(`https://${url}/`, "_blank");
};
